import BSWildRiceProduct from 'models/BSWildRiceProduct'

export const packagingInitialState = {
  category: BSWildRiceProduct.category,
  subCategory: BSWildRiceProduct.subCategory,
  GrainLength: BSWildRiceProduct.GrainLength,
  Size: BSWildRiceProduct.Size,
}

export const grainLengthOptions = [
  {
    value: '',
    label: 'Grain Length',
    isDisabled: true,
  },
  {
    value: 'Short',
    label: 'Short',
  },
  { value: 'Medium', label: 'Medium' },
  { value: 'Long', label: 'Long' },
  { value: 'Extra Long', label: 'Extra Long' },
]
